import { useEffect } from 'react';
import GenericButton from '../components/button/GenericButton';

import '../index.css';
import './HowToPlayScreen.css';
import { removeFromLocalStorage } from '../utils/storage';
import AnimatedSnowImage from '../components/AnimatedSnowImage';

const HowToPlayScreen = ({ isPaused = false, onPause }) => {
  useEffect(() => {
    removeFromLocalStorage('gameSessionStarted');
  }, []);
  return (
    <div className='how-to-play-screen blue-bg'>
      <div className='how-to-play-content'>
        <AnimatedSnowImage />
        <img
          src='/assets/snowman-bg-htp.png'
          alt='Snowman'
          width='90%'
          className='howtoplay-image'
        />
        <span className='text-gold how-to-play-title'>HOW TO PLAY</span>
        <div className='items-container'>
          <div className='item-to-play'>
            <img
              src='/assets/arrows-icon.png'
              alt='arrows keys'
              width='30'
              className='how-to-play-icon'
            />
            <p>
              Use the arrow keys to shift the snowman side to side to catch
              presents
            </p>
          </div>
          <div className='item-to-play'>
            <img
              src='/assets/present-icon.png'
              alt='present icon'
              width='30'
              className='how-to-play-icon'
            />
            <p>Presents are worth 100 points</p>
          </div>
          <div className='item-to-play'>
            <img
              src='/assets/card-icon.png'
              alt='card icon'
              width='30'
              className='how-to-play-icon'
            />
            <p>Holiday scratch-offs are worth 1,000 points</p>
          </div>
          <div className='item-to-play'>
            <img
              src='/assets/timer-icon.png'
              alt='timer icon'
              width='30'
              className='how-to-play-icon'
            />
            <p>Catch as many gifts as you can in 60 seconds</p>
          </div>
          <div className='item-to-play'>
            <img
              src='/assets/money-icon.png'
              alt='money icon'
              width='30'
              className='how-to-play-icon'
            />
            <p>
              After completing the game, enter for a chance to win Holiday
              scratch-offs
            </p>
          </div>
        </div>
        {!isPaused && <GenericButton page='/game-play?from=new' text='START' />}
        {isPaused && (
          <button className={'generic-button'} onClick={onPause}>
            <span>RESUME</span>
          </button>
        )}
      </div>
      <div className='how-to-play-images'>
        <img
          className='snow-image-1-htp'
          src='/assets/snowman-snow-1.png'
          alt='Snowman'
          width='100%'
        />
        <img
          className='snow-image-2-htp'
          src='/assets/snowman-snow-2.png'
          alt='Snowman'
          width='100%'
        />
        <img
          className='snowman-gift'
          src='/assets/snowman-gifts.png'
          alt='Snowman'
          width='100%'
        />
      </div>
    </div>
  );
};

export default HowToPlayScreen;
